import AddModal from "./AddModal";
import EditModal from "./EditModal";
import Main from "./Main";

export default { AddModal, EditModal, Main };
